import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../i18n";
import { api } from "../../lib/api";
import { Switch } from "../ui/switch";

export const EmailPrefs = ({ cats = ["orders", "approvals", "payments", "hr"] }) => {
  const { t } = useI18n();
  const [prefs, setPrefs] = useState(null);
  useEffect(() => {
    api.get("/auth/me/email-prefs").then((r) => setPrefs(r.data)).catch(() => {});
  }, []);
  const toggle = (k, v) => {
    const next = { ...prefs, [k]: v };
    setPrefs(next);
    api.put("/auth/me/email-prefs", next).then(() => toast.success(t("x.mail.saved"))).catch(() => toast.error(t("common.error")));
  };
  return (
    <section className="rounded-2xl bg-white p-5 shadow-sm" data-testid="email-prefs">
      <h2 className="flex items-center gap-2 text-base font-semibold text-navy md:text-lg"><Mail className="h-5 w-5" />{t("x.mail.prefsTitle")}</h2>
      <p className="mt-1 text-xs text-slate-500">{t("x.mail.prefsSub")}</p>
      {prefs && <ul className="mt-3 divide-y divide-slate-100">
        {cats.map((k) => (
          <li key={k} className="flex min-h-12 items-center justify-between gap-3 text-sm text-ink">
            <span>{t(`x.mail.cat.${k}`)}</span>
            <Switch checked={prefs[k]} onCheckedChange={(v) => toggle(k, v)} data-testid={`email-pref-${k}`} className="data-[state=checked]:bg-navy" />
          </li>
        ))}
      </ul>}
    </section>
  );
};
